import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommunicationStatus } from './communication-status.interface';
import { CommunicationStatusService } from './communication-status.service';

const service = new CommunicationStatusService();

export interface CommunicationStatusState {
   communicationStatuses: Array<CommunicationStatus>;
}

const CommunicationStatusStore: Module<CommunicationStatusState, StoreState> = {
   namespaced: true,
   state: { communicationStatuses: [] },
   getters: { communicationStatuses: (state) => state.communicationStatuses },
   mutations: {
      SET_COMMUNICATION_STATUSES(state, communicationStatuses: Array<CommunicationStatus>) {
         state.communicationStatuses = communicationStatuses;
      },
   },
   actions: {
      async getCommunicationStatuses(context, query: LocationQuery) {
         const response = await service.getCommunicationStatusses(query);
         context.commit('SET_COMMUNICATION_STATUSES', response.data);
         return response.data;
      },
   },
};

export default CommunicationStatusStore;
